import React from 'react';

export const VehicleDetailsSkeleton = () => {
  return (
    <div className="min-h-screen bg-[#F5F8F9] animate-pulse">
      <div className="max-w-[1600px] mx-auto p-6 space-y-8">
        {/* Back Button Skeleton */}
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-xl bg-gray-200 w-10 h-10"></div>
          <div className="h-4 bg-gray-200 rounded w-12"></div>
        </div>

        {/* Header Section Skeleton */}
        <div className="flex flex-col sm:flex-row justify-between items-start gap-4 w-full bg-white rounded-xl p-6">
          <div className="flex items-center space-x-4 w-full">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-gray-200 rounded-full"></div>
            </div>
            <div className="w-full">
              <div className="h-8 bg-gray-200 rounded w-48 mb-2"></div>
              <div className="flex flex-wrap items-center gap-4">
                <div className="h-4 bg-gray-200 rounded w-24"></div>
                <div className="h-4 bg-gray-200 rounded w-20"></div>
                <div className="h-4 bg-gray-200 rounded w-16"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Tab Navigation Skeleton */}
        <div className="bg-white rounded-xl p-1">
          <div className="flex space-x-1">
            {[...Array(4)].map((_, index) => (
              <div
                key={index}
                className="h-10 bg-gray-200 rounded-lg flex-1"
              ></div>
            ))}
          </div>
        </div>

        {/* Content Area Skeleton */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl p-6">
            <div className="h-6 bg-gray-200 rounded w-40 mb-6"></div>
            <div className="space-y-4">
              {[...Array(6)].map((_, index) => (
                <div key={index} className="space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-32"></div>
                  <div className="h-4 bg-gray-200 rounded w-48"></div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-xl p-6">
            <div className="h-6 bg-gray-200 rounded w-36 mb-6"></div>
            <div className="space-y-4">
              {[...Array(3)].map((_, index) => (
                <div key={index} className="space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-28"></div>
                  <div className="h-4 bg-gray-200 rounded w-52"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
